/** Who uploaded a material. Mirrors the backend MaterialUploaderContract enum. */
export enum MaterialUploader {
  Instructor = "Instructor",
  Member = "Member",
}
